import { ICurrency, IExpense, IExpenseCreate, IExpenseFilter, IExpenseUpdate } from "../models/IExpense";
import { configWithUserFileToken, configWithUserToken } from "./config";

export const getExpenses = (filter: IExpenseFilter = {}) => {
  const p = new URLSearchParams();
  if (filter.spentByUserId) p.append("SpentByUserId", filter.spentByUserId);
  if (filter.isReimbursed !== undefined) p.append("IsReimbursed", String(filter.isReimbursed));
  if (filter.from) p.append("From", filter.from);
  if (filter.to) p.append("To", filter.to);
  const qs = p.toString();
  return configWithUserToken.get<IExpense[]>(`Expense${qs ? `?${qs}` : ""}`);
};

export const createExpense = (data: IExpenseCreate) => {
  const form = new FormData();
  form.append("SpentByUserId", data.spentByUserId);
  form.append("Amount", String(data.amount));
  form.append("CurrencyId", data.currencyId);
  form.append("SpentAt", data.spentAt);
  form.append("Description", data.description);
  if (data.vendorId) form.append("VendorId", data.vendorId);
  data.documents?.forEach((f) => form.append("documents", f));
  return configWithUserFileToken.post<IExpense>("Expense", form);
};

export const updateExpense = (expenseId: string, data: IExpenseUpdate) =>
  configWithUserToken.put<IExpense>(`Expense/${expenseId}`, data);

export const deleteExpense = (expenseId: string) =>
  configWithUserToken.delete(`Expense/${expenseId}`);

export const addExpenseDocuments = (expenseId: string, files: File[]) => {
  const form = new FormData();
  files.forEach((f) => form.append("documents", f));
  return configWithUserFileToken.post(`Expense/${expenseId}/documents`, form);
};

export const deleteExpenseDocument = (documentId: string) =>
  configWithUserToken.delete(`Expense/documents/${documentId}`);

export const getPlatformCurrencyList = () =>
  configWithUserToken.get<ICurrency[]>("Currency/PlatformCurrencyList");

export const patchExpenseReimbursed = (expenseId: string, isReimbursed: boolean) =>
  configWithUserToken.patch(`Expense/${expenseId}/reimbursed`, { isReimbursed });
